import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import ReportVisit from "../../../containers/modules/sales/report-visit";

export default function VisitSalesRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="visit-sales"
      index
      element={
        <AccessControl
          name={"Report Visit Sales"}
          auth={authUser}
          component={() => <ReportVisit />}
        />
      }
    ></Route>
  );
}
